/** User-facing location: "{City} in {State}" */
export const formatStateInCity = (state, city) => {
  const sn = state?.state_name?.trim();
  const cn = city?.city_name?.trim();
  if (sn && cn) return `${cn} in ${sn}`;
  return cn || sn || null;
};

export const formatStateInCityFromIds = (stateId, cityId, states = [], cities = []) => {
  const state = states.find((s) => Number(s.id) === Number(stateId));
  const city = cities.find((c) => Number(c.id) === Number(cityId));
  return formatStateInCity(state, city);
};

/** Map pin label for admin / partner */
export const getMapPinLabel = (property) => {
  if (!property) return '—';
  return (
    property.map_location_name?.trim() ||
    property.address?.trim() ||
    property.location?.trim() ||
    '—'
  );
};

export const hasMapPin = (property) => {
  const lat = Number(property?.latitude);
  const lng = Number(property?.longitude);
  return Number.isFinite(lat) && Number.isFinite(lng);
};

export const PROPERTY_STATUS_LABELS = {
  1: 'Awaiting',
  2: 'Approved',
  3: 'Rejected',
  4: 'Sold Out',
};

export const getPropertyStatusLabel = (statusId) =>
  PROPERTY_STATUS_LABELS[Number(statusId)] || 'Unknown';
